import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

function LinePlaneArrivalIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M21.12 16.23a4.9994 4.9994 0 0 0-2.3-3L16.71 12l-.48-5.47a.9988.9988 0 0 0-.49-.78l-3-1.72a.9998.9998 0 0 0-1 0 1 1 0 0 0-.52.84l-.15 3.9-1.75-1-2.86-3.85a1 1 0 0 0-1.78.41l-.87 4.61a3 3 0 0 0 1.39 3.29l14.06 8.11a1.0003 1.0003 0 0 0 1.36-.34 4.9103 4.9103 0 0 0 .5-3.77ZM19.24 18 6.2 10.5a1 1 0 0 1-.44-1.13l.46-2.44 1.66 2.2a1 1 0 0 0 .3.27l3.35 1.94a.9997.9997 0 0 0 .9848.0093.9995.9995 0 0 0 .5152-.8393l.16-3.9 1.09.63.48 5.47a1.0003 1.0003 0 0 0 .5.78L17.82 15a2.909 2.909 0 0 1 1.36 1.78c.1116.397.1321.814.06 1.22Z"/>
  </SvgIcon>
}

export default LinePlaneArrivalIcon
